import { z } from "zod";
export const CapabilityKindSchema = z.enum(["tool", "entity_type", "provider"]);
/** One indexed capability (an installed tool, entity type or provider). */
export const CapabilityEntrySchema = z.object({
    kind: CapabilityKindSchema,
    /** Tool name, entity type name or provider id. */
    name: z.string().min(1),
    moduleId: z.string().nullable(),
    description: z.string().min(1),
    /** Provider status; tools and entity types are "ok" while installed. */
    status: z.enum(["ok", "degraded", "down"]),
});
export const CoverageSchema = z.enum(["covered", "partial", "missing"]);
//# sourceMappingURL=capability.js.map